'use client';

import { Stack } from '@chakra-ui/react';
import { NoResults } from './components/NoResults';
import { PlaceCard } from '../cards/PlaceCard';
import { Database } from '@habity/types';

type Place = Database['public']['Tables']['places']['Row'];

type PlacesListProps = {
  places?: Place[] | null;
  isLoading: boolean;
  setLastElement?: TODO | null;
};

export function PlacesList({ places, isLoading }: PlacesListProps) {
  if (!places?.length) {
    return <NoResults tab="places" />;
  }

  return (
    <Stack spacing="0">
      {places.map((place, index) => (
        <PlaceCard
          key={place.id || index}
          place={place}
          isLoading={isLoading || false}
        />
      ))}
    </Stack>
  );
}
